(function () {
  function postJson(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload || {}),
    }).then(function (response) {
      if (!response.ok) {
        throw new Error('Request failed');
      }
      return response.json();
    });
  }

  function showMessage(text) {
    var box = document.getElementById('heathen-cart-messages');
    if (!box) return;
    box.textContent = text;
    box.hidden = false;
  }

  function getRootUrl(path) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/';
    return root + path.replace(/^\//, '');
  }

  function bindRemoveButtons(scope) {
    (scope || document).querySelectorAll('[data-heathen-remove]').forEach(function (button) {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', function () {
        var line = Number(button.getAttribute('data-line'));
        if (!line) return;
        if (!window.confirm('Czy na pewno chcesz usunąć ten produkt z koszyka?')) return;
        postJson(getRootUrl('/cart/change.js'), { line: line, quantity: 0 })
          .then(function () {
            window.location.reload();
          })
          .catch(function () {
            showMessage('Wystąpił błąd podczas usuwania produktu z koszyka.');
          });
      });
    });
  }

  function bindClearButton(scope) {
    var button = (scope || document).querySelector('[data-heathen-clear]');
    if (!button || button.dataset.bound === 'true') return;
    button.dataset.bound = 'true';
    button.addEventListener('click', function () {
      if (!window.confirm('Czy na pewno chcesz wyczyścić cały koszyk?')) return;
      fetch(getRootUrl('/cart/clear.js'), { method: 'POST' })
        .then(function (response) {
          if (!response.ok) throw new Error('clear-failed');
          return response.json();
        })
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          showMessage('Wystąpił błąd podczas czyszczenia koszyka.');
        });
    });
  }

  function bindSaveAsList(scope) {
    var button = (scope || document).querySelector('[data-save-as-list]');
    if (!button || button.dataset.bound === 'true') return;
    button.dataset.bound = 'true';
    button.addEventListener('click', function () {
      if (!window.HeathenWishlist || typeof window.HeathenWishlist.add !== 'function') {
        return;
      }
      var added = 0;
      document.querySelectorAll('.cart-item[data-product-handle]').forEach(function (item) {
        var handle = item.getAttribute('data-product-handle');
        if (!handle) return;
        if (window.HeathenWishlist.has && window.HeathenWishlist.has(handle)) return;
        window.HeathenWishlist.add(handle);
        added += 1;
      });
      if (added > 0) {
        showMessage('Produkty zostały dodane do listy ulubionych.');
      } else {
        showMessage('Wszystkie produkty z koszyka są już na liście ulubionych.');
      }
    });
  }

  function bindRecommendationArrows(scope) {
    var root = scope || document;
    var track = root.querySelector('[data-reco-track]');
    if (!track) return;
    var prev = root.querySelector('[data-reco-prev]');
    var next = root.querySelector('[data-reco-next]');
    if (prev && prev.dataset.bound !== 'true') {
      prev.dataset.bound = 'true';
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -Math.max(320, track.clientWidth * 0.65), behavior: 'smooth' });
      });
    }
    if (next && next.dataset.bound !== 'true') {
      next.dataset.bound = 'true';
      next.addEventListener('click', function () {
        track.scrollBy({ left: Math.max(320, track.clientWidth * 0.65), behavior: 'smooth' });
      });
    }
  }

  function normalizeHandle(value) {
    if (!value) return '';
    return String(value).trim().toLowerCase().replace(/[^a-z0-9\-]/g, '');
  }

  function parseMoney(cents) {
    var amount = Number(cents || 0) / 100;
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'PLN';
    try {
      return new Intl.NumberFormat('pl-PL', { style: 'currency', currency: currency }).format(amount);
    } catch (e) {
      return amount.toFixed(2) + ' ' + currency;
    }
  }

  function extractProductSize(product) {
    if (!product || !Array.isArray(product.options) || !Array.isArray(product.variants) || !product.variants.length) return '-';
    var variant = product.variants[0];
    var sizeIndex = -1;
    for (var i = 0; i < product.options.length; i++) {
      var optionName = String(product.options[i] || '').toLowerCase();
      if (optionName === 'size' || optionName === 'rozmiar') {
        sizeIndex = i;
        break;
      }
    }
    if (sizeIndex === -1) return '-';
    var key = 'option' + (sizeIndex + 1);
    return variant[key] || '-';
  }

  function normalizeSize(value) {
    if (value === null || value === undefined) return '-';
    var out = String(value).trim();
    return out || '-';
  }

  function extractSizeFromProductHtml(html) {
    if (!html) return '-';
    try {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var selectors = ['.heathen-pdp-size-row .value', '[data-product-size]', '.product-size-value'];
      for (var i = 0; i < selectors.length; i++) {
        var node = doc.querySelector(selectors[i]);
        if (node && node.textContent) {
          var found = normalizeSize(node.textContent);
          if (found !== '-') return found;
        }
      }
    } catch (e) {}
    return '-';
  }

  function fetchSizeFromProductPage(handle) {
    var normalized = normalizeHandle(handle);
    if (!normalized) return Promise.resolve('-');
    return fetch(getRootUrl('/products/' + normalized), { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) return '-';
        return response.text().then(function (html) {
          return extractSizeFromProductHtml(html);
        });
      })
      .catch(function () {
        return '-';
      });
  }

  function buildRecommendationCard(product, sizeLabel, resolvedSize) {
    var title = String(product.title || '');
    var safeTitle = title.replace(/"/g, '&quot;');
    var productUrl = product.url || '/products/' + encodeURIComponent(product.handle || '');
    var image = product.featured_image || (Array.isArray(product.images) && product.images[0]) || '';
    var price = product.price != null ? product.price : product.price_min;
    var sizeValue = normalizeSize(resolvedSize);
    if (sizeValue === '-') sizeValue = extractProductSize(product);
    sizeValue = normalizeSize(sizeValue);

    return (
      '<a href="' +
      productUrl +
      '" style="width: 100%; display: inline-block;">' +
      '<div class="product-item">' +
      '<div class="product-image">' +
      '<div class="background-overlay-grey" role="presentation" aria-hidden="true"></div>' +
      (image ? '<img src="' + image + '" alt="' + safeTitle + '" class="lazyload" loading="lazy">' : '') +
      '</div>' +
      '<div class="product-brand">' +
      (product.vendor || '-') +
      '</div>' +
      '<div class="product-name" title="' +
      safeTitle +
      '" aria-label="' +
      safeTitle +
      '">' +
      title +
      '</div>' +
      '<div class="product-price"><span class="regular-price" style="color: #232323;">' +
      parseMoney(price) +
      '</span></div>' +
      '<div class="product-size">' +
      sizeLabel +
      ': ' +
      sizeValue +
      '</div>' +
      '</div>' +
      '</a>'
    );
  }

  function recommendationStep(slider) {
    var first = slider.querySelector('a');
    if (!first) return 360;
    var style = window.getComputedStyle(slider);
    var gap = parseFloat(style.gap || style.columnGap || '4') || 0;
    return first.getBoundingClientRect().width + gap;
  }

  function updateRecommendationArrows(root, slider) {
    var prev = root.querySelector('[data-reco-prev]');
    var next = root.querySelector('[data-reco-next]');
    if (!prev || !next) return;
    var maxScroll = Math.max(0, slider.scrollWidth - slider.clientWidth - 1);
    var atStart = slider.scrollLeft <= 1;
    var atEnd = maxScroll <= 0 || slider.scrollLeft >= maxScroll - 1;
    prev.classList.toggle('slick-disabled', atStart);
    next.classList.toggle('slick-disabled', atEnd);
    prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
  }

  function bindRecommendationSlider(root, slider) {
    var prev = root.querySelector('[data-reco-prev]');
    var next = root.querySelector('[data-reco-next]');
    if (prev && prev.dataset.bound !== 'true') {
      prev.dataset.bound = 'true';
      prev.addEventListener('click', function () {
        slider.scrollBy({ left: -recommendationStep(slider), behavior: 'smooth' });
      });
    }
    if (next && next.dataset.bound !== 'true') {
      next.dataset.bound = 'true';
      next.addEventListener('click', function () {
        slider.scrollBy({ left: recommendationStep(slider), behavior: 'smooth' });
      });
    }
    slider.addEventListener('scroll', function () {
      updateRecommendationArrows(root, slider);
    });
    window.addEventListener('resize', function () {
      updateRecommendationArrows(root, slider);
    });
    updateRecommendationArrows(root, slider);
  }

  function fetchRecommendationsByProduct(productId, limit) {
    if (!productId) return Promise.resolve([]);
    return fetch(getRootUrl('/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=' + encodeURIComponent(limit) + '&intent=related'))
      .then(function (response) {
        if (!response.ok) return [];
        return response.json().then(function (data) {
          return data && Array.isArray(data.products) ? data.products : [];
        });
      })
      .catch(function () {
        return [];
      });
  }

  function isArchivedProduct(product) {
    if (!product) return false;
    if (product.available === false) return true;

    var metafields = product.metafields || {};
    var customMeta = metafields.custom || {};
    var magentoMeta = metafields.magento || {};
    var archiveMeta =
      (customMeta.is_archived && (customMeta.is_archived.value || customMeta.is_archived)) ||
      (magentoMeta.is_archived && (magentoMeta.is_archived.value || magentoMeta.is_archived));

    if (archiveMeta !== undefined && archiveMeta !== null && String(archiveMeta).trim() !== '') {
      var normalizedMeta = String(archiveMeta).trim().toLowerCase();
      if (normalizedMeta === 'true' || normalizedMeta === '1' || normalizedMeta === 'yes') return true;
    }

    var tags = Array.isArray(product.tags) ? product.tags : [];
    for (var i = 0; i < tags.length; i += 1) {
      var normalizedTag = String(tags[i] || '').trim().toLowerCase();
      if (
        normalizedTag === 'archiwum' ||
        normalizedTag === 'archive' ||
        normalizedTag === 'archived' ||
        normalizedTag === 'sold' ||
        normalizedTag === 'sold-out' ||
        normalizedTag === 'sold_out'
      ) {
        return true;
      }
    }

    return false;
  }

  function fetchFallbackProducts(limit) {
    return fetch(getRootUrl('/products.json?limit=' + encodeURIComponent(limit)))
      .then(function (response) {
        if (!response.ok) return [];
        return response.json().then(function (data) {
          return data && Array.isArray(data.products) ? data.products : [];
        });
      })
      .catch(function () {
        return [];
      });
  }

  function renderCartRecommendations(scope) {
    var root = (scope || document).querySelector('[data-heathen-cart-recommended-root]');
    if (!root) return;
    var slider = root.querySelector('[data-reco-track]');
    if (!slider) return;
    var loader = root.querySelector('[data-reco-loading]');
    var overlay = root.querySelector('[data-reco-overlay]');
    var empty = root.querySelector('[data-reco-empty]');
    var sizeLabel = root.getAttribute('data-size-label') || 'Rozmiar';
    var emptyMessage = root.getAttribute('data-empty-message') || 'Brak rekomendowanych produktów.';
    var limit = parseInt(root.getAttribute('data-limit') || '8', 10);
    if (!Number.isFinite(limit) || limit < 1) limit = 8;

    var cartItems = Array.prototype.slice
      .call(document.querySelectorAll('.cart-item[data-product-id][data-product-handle]'))
      .map(function (node) {
        return {
          id: Number(node.getAttribute('data-product-id')),
          handle: normalizeHandle(node.getAttribute('data-product-handle')),
        };
      })
      .filter(function (item) {
        return item.id && item.handle;
      });

    if (!cartItems.length) return;

    var cartHandles = {};
    cartItems.forEach(function (item) {
      cartHandles[item.handle] = true;
    });

    if (overlay) overlay.hidden = false;

    Promise.all(
      cartItems.map(function (item) {
        return fetchRecommendationsByProduct(item.id, Math.max(limit, 12));
      })
    )
      .then(function (responses) {
        var merged = [];
        var seen = {};

        responses.forEach(function (products) {
          products.forEach(function (product) {
            var handle = normalizeHandle(product && product.handle);
            if (!handle) return;
            if (isArchivedProduct(product)) return;
            if (cartHandles[handle]) return;
            if (seen[handle]) return;
            seen[handle] = true;
            merged.push(product);
          });
        });

        if (merged.length >= limit) return merged.slice(0, limit);

        return fetchFallbackProducts(Math.max(24, limit * 2)).then(function (fallbacks) {
          fallbacks.forEach(function (product) {
            var handle = normalizeHandle(product && product.handle);
            if (!handle) return;
            if (isArchivedProduct(product)) return;
            if (cartHandles[handle]) return;
            if (seen[handle]) return;
            seen[handle] = true;
            merged.push(product);
          });
          return merged.slice(0, limit);
        });
      })
      .then(function (products) {
        if (!products || !products.length) {
          if (empty) {
            empty.textContent = emptyMessage;
            empty.hidden = false;
          }
          slider.innerHTML = '';
          return;
        }

        return Promise.all(
          products.map(function (product) {
            return fetchSizeFromProductPage(product.handle).then(function (resolvedSize) {
              return {
                product: product,
                resolvedSize: resolvedSize,
              };
            });
          })
        ).then(function (rows) {
          slider.innerHTML = rows
            .map(function (row) {
              return buildRecommendationCard(row.product, sizeLabel, row.resolvedSize);
            })
            .join('');

          if (empty) empty.hidden = true;
          bindRecommendationSlider(root, slider);
        });
      })
      .finally(function () {
        if (loader) loader.classList.add('hidden');
        if (overlay) overlay.hidden = true;
      });
  }

  function bindDiscountCheckout(scope) {
    var root = scope || document;
    var discountInput = root.querySelector('#heathen-cart-discount-code');
    var checkout = root.querySelector('#heathen-cart-checkout');
    if (!discountInput || !checkout || discountInput.dataset.bound === 'true') return;
    discountInput.dataset.bound = 'true';
    var requiresLogin = checkout.getAttribute('data-requires-login') === 'true';
    var checkoutBase = checkout.getAttribute('data-checkout-base') || '/checkout';
    var checkoutPath = checkout.getAttribute('data-checkout-path') || '/checkout';
    var syncHref = function () {
      var code = (discountInput.value || '').trim();
      if (requiresLogin) {
        var returnPath = code ? checkoutPath + '?discount=' + encodeURIComponent(code) : checkoutPath;
        checkout.href = checkoutBase + '?return_url=' + encodeURIComponent(returnPath);
        return;
      }
      checkout.href = code ? checkoutBase + '?discount=' + encodeURIComponent(code) : checkoutBase;
    };
    discountInput.addEventListener('input', syncHref);
    syncHref();
  }

  function init() {
    var section = document.querySelector('.heathen-cart-page');
    if (!section) return;
    bindRemoveButtons(section);
    bindClearButton(section);
    bindSaveAsList(section);
    renderCartRecommendations(section);
    bindDiscountCheckout(section);
  }

  document.addEventListener('DOMContentLoaded', init);
})();
